import {
  BehaviorNode as BehaviorNodeType,
  BindingExpression,
} from "../../types.js";
import {
  BehaviorEdge,
  ExecutionContext,
  NodeExecutionResult,
} from "../types.js";

export abstract class BehaviorNode {
  public incomingEdgesByPort: Map<string, BehaviorEdge[]> = new Map();
  public outgoingEdgesByPort: Map<string, BehaviorEdge[]> = new Map();
  constructor(public readonly behavior: BehaviorNodeType) {}

  abstract execute(context: ExecutionContext): NodeExecutionResult;
  abstract getOutput(
    portId: string,
    visiting: Set<string>,
    context: ExecutionContext,
    binding?: boolean,
  ): unknown;

  getInput(
    portId: string,
    visiting: Set<string>,
    context: ExecutionContext,
    binding: boolean = false,
  ): unknown {
    const incoming = this.incomingEdgesByPort.get(portId);
    if (incoming) {
      if (incoming.length > 1) {
        throw new Error(`Multiple incoming connections for port ${portId}`);
      }
      return incoming[0]!.fromNode.getOutput(
        incoming[0]!.fromPort,
        visiting,
        context,
        binding,
      );
    }
    const exactPort = this.behavior.ports.find((port) => port.id === portId);
    if (binding) {
      return {
        kind: "literal",
        value: exactPort?.value,
      } as BindingExpression;
    }
    return exactPort?.value;
  }

  getValueType(portId: string): string {
    const exactPort = this.behavior.ports.find((port) => port.id === portId);
    return exactPort?.valueType ?? "unknown";
  }

  getInputValueType(portId: string): string {
    const exactPort = this.behavior.ports.find((port) => port.id === portId);
    return exactPort?.valueType ?? "unknown";
  }
}
